export default "__VITE_ASSET__cfdc3f57__"